import React from 'react';
import ReferenceDF from '../components/SimulatorsComponents/DefualtSimulators/ReferenceDF';
//= ========================================================================

const Sim_B09_SendMoneyReference = ({
  globJSON,
  selectedScreen,
  simPlatform,
  slideshowRefs = null,
}) => (
  <ReferenceDF
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
  />
);

export default Sim_B09_SendMoneyReference;
